<div nz-row nzGutter="25">
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Basic</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-rate-basic></nz-demo-rate-basic>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Half star</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-rate-half></nz-demo-rate-half>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Clear star</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-rate-clear></nz-demo-rate-clear>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Read only</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-rate-disabled></nz-demo-rate-disabled>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Customize Character</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-rate-character></nz-demo-rate-character>
      </div>
    </div>
  </div>
</div>
